import * as Types from './types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetEnergyUsageExpandedV2EtsSumAggregateQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>;
}>;


export type GetEnergyUsageExpandedV2EtsSumAggregateQuery = { __typename?: 'query_root', container_insights_energy_usage_expanded_v2_aggregate: { __typename?: 'container_insights_energy_usage_expanded_v2_aggregate', aggregate?: { __typename?: 'container_insights_energy_usage_expanded_v2_aggregate_fields', sum?: { __typename?: 'container_insights_energy_usage_expanded_v2_sum_fields', ets_euro?: any | null } | null } | null } };


export const GetEnergyUsageExpandedV2EtsSumAggregateDocument = gql`
    query GetEnergyUsageExpandedV2ETSSumAggregate($where: container_insights_energy_usage_expanded_v2_bool_exp) {
  container_insights_energy_usage_expanded_v2_aggregate(
    where: $where
    order_by: {datetime: asc}
  ) {
    aggregate {
      sum {
        ets_euro
      }
    }
  }
}
    `;

export function useGetEnergyUsageExpandedV2EtsSumAggregateQuery(options?: Omit<Urql.UseQueryArgs<GetEnergyUsageExpandedV2EtsSumAggregateQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEnergyUsageExpandedV2EtsSumAggregateQuery, GetEnergyUsageExpandedV2EtsSumAggregateQueryVariables>({ query: GetEnergyUsageExpandedV2EtsSumAggregateDocument, ...options });
};